import { render, staticRenderFns } from "./Regulation.vue?vue&type=template&id=4c8eee61&"
import script from "./Regulation.vue?vue&type=script&lang=js&"
export * from "./Regulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports